import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ConfirmModal from './ConfirmModal';

export default function Restock() {
  const [materials, setMaterials] = useState([]);
  const [history, setHistory] = useState([]);
  const [rows, setRows] = useState([{ material_id: '', qty: '', price_incl_vat: '' }]);
  const [refNo, setRefNo] = useState('');
  const [notes, setNotes] = useState('');
  const [confirm, setConfirm] = useState(false);
  const [msg, setMsg] = useState({ text:'', ok:true });

  useEffect(() => {
    axios.get('/api/materials').then(r => setMaterials(r.data));
    axios.get('/api/restock').then(r => setHistory(r.data));
  }, []);

  const addRow = () => setRows(r => [...r, { material_id: '', qty: '', price_incl_vat: '' }]);
  const removeRow = (i) => setRows(r => r.filter((_, idx) => idx !== i));
  const updateRow = (i, k, v) => setRows(r => r.map((row, idx) => idx === i ? { ...row, [k]: v } : row));
  const calcExcl = (incl) => incl ? (parseFloat(incl) / 1.07).toFixed(2) : '—';
  const totalIncl = rows.reduce((s, r) => s + (parseFloat(r.price_incl_vat) || 0), 0);
  const totalExcl = totalIncl / 1.07;
  const vatAmt = totalIncl - totalExcl;

  const handleSubmit = async () => {
    try {
      await axios.post('/api/restock', {
        ref_no: refNo, notes,
        items: rows.filter(r => r.material_id && r.qty && r.price_incl_vat),
        vat_pct: 7
      });
      setMsg({ text:'บันทึกการเติมสต็อกสำเร็จ', ok:true });
      setRows([{ material_id: '', qty: '', price_incl_vat: '' }]);
      setRefNo(''); setNotes('');
      axios.get('/api/restock').then(r => setHistory(r.data));
      setTimeout(() => setMsg({text:'',ok:true}), 3000);
    } catch (err) {
      setMsg({ text: err.response?.data?.error || 'เกิดข้อผิดพลาด', ok:false });
    }
    setConfirm(false);
  };

  return (
    <div>
      {confirm && <ConfirmModal title="ยืนยันเติมสต็อก" body={`ยืนยันการเติมสต็อก รวม ฿${totalIncl.toFixed(2)} (incl. VAT 7%)?`} onConfirm={handleSubmit} onCancel={() => setConfirm(false)}/>}
      {msg.text && <div className={`alert ${msg.ok?'alert-success':'alert-danger'}`}>{msg.text}</div>}

      <div className="sh">บันทึกการรับวัตถุดิบ</div>
      <div className="glass-card">
        <div className="grid-2" style={{ marginBottom:12 }}>
          <div className="form-group"><label className="fl">เลขที่ใบสั่งซื้อ</label><input className="fi" value={refNo} onChange={e => setRefNo(e.target.value)} placeholder="PO-2024-001"/></div>
          <div className="form-group"><label className="fl">หมายเหตุ</label><input className="fi" value={notes} onChange={e => setNotes(e.target.value)} placeholder="หมายเหตุ"/></div>
        </div>

        <div className="divider"/>
        <div style={{ display:'grid',gridTemplateColumns:'2fr 1fr 1fr 1fr auto',gap:6,marginBottom:6 }}>
          <div className="fl">วัตถุดิบ</div><div className="fl">จำนวน</div><div className="fl">incl. VAT</div><div className="fl">excl. VAT</div><div/>
        </div>
        {rows.map((row, i) => (
          <div key={i} style={{ display:'grid',gridTemplateColumns:'2fr 1fr 1fr 1fr auto',gap:6,marginBottom:6,alignItems:'center' }}>
            <select className="fi" value={row.material_id} onChange={e => updateRow(i,'material_id',e.target.value)}>
              <option value="">เลือกวัตถุดิบ</option>
              {materials.map(m => <option key={m.id} value={m.id}>{m.name} ({m.unit})</option>)}
            </select>
            <input className="fi" type="number" placeholder="qty" value={row.qty} onChange={e => updateRow(i,'qty',e.target.value)}/>
            <input className="fi" type="number" placeholder="฿" value={row.price_incl_vat} onChange={e => updateRow(i,'price_incl_vat',e.target.value)}/>
            <input className="fi" readOnly value={row.price_incl_vat ? `฿${calcExcl(row.price_incl_vat)}` : '—'} style={{ background:'#f7f5f2',color:'var(--text-muted)' }}/>
            <button className="btn-secondary" style={{ padding:'7px 10px' }} onClick={() => removeRow(i)}>✕</button>
          </div>
        ))}
        <button className="btn-secondary" style={{ fontSize:11,padding:'5px 12px',marginBottom:12 }} onClick={addRow}>+ เพิ่มรายการ</button>

        <div className="divider"/>
        <div style={{ background:'var(--success-bg)',border:'1px solid var(--success-border)',borderRadius:8,padding:'10px 14px' }}>
          <div style={{ display:'flex',justifyContent:'space-between',fontSize:12,color:'var(--text-secondary)',marginBottom:3 }}><span>excl. VAT</span><span>฿{totalExcl.toFixed(2)}</span></div>
          <div style={{ display:'flex',justifyContent:'space-between',fontSize:12,color:'var(--text-secondary)',marginBottom:3 }}><span>VAT 7%</span><span>฿{vatAmt.toFixed(2)}</span></div>
          <div style={{ display:'flex',justifyContent:'space-between',fontSize:13,fontWeight:700,color:'var(--success)' }}><span>รวม incl. VAT</span><span>฿{totalIncl.toFixed(2)}</span></div>
        </div>

        <div className="btn-row">
          <button className="btn-primary" onClick={() => setConfirm(true)}>ยืนยันเติมสต็อก</button>
        </div>
      </div>

      <div className="sh">ประวัติการเติมสต็อก</div>
      <div className="glass-card">
        <table className="tbl">
          <thead><tr><th>วันที่</th><th>เลขที่</th><th>รวม incl. VAT</th><th>โดย</th></tr></thead>
          <tbody>
            {history.map(h => (
              <tr key={h.id}>
                <td>{new Date(h.created_at).toLocaleDateString('th-TH')}</td>
                <td>{h.ref_no || '—'}</td>
                <td style={{ fontWeight:600 }}>฿{parseFloat(h.total_incl_vat).toFixed(2)}</td>
                <td>{h.created_by_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
